import React, {Fragment, useCallback, useEffect} from 'react';
import {compose} from "redux";
import {translate} from "react-i18next";
import {Button, Col, Divider, Row} from "antd";
import {
  changeElPublishDataflow,
  changeElTranscodeDataflow,
  createELDsd,
  createELArtefacts,
  getELDataImportStatus,
  hideElMetadataReport,
  preloadELCSV,
  resetEl,
  setELLoadTableExists,
  submitELDataCreate,
  submitELDataUpdate,
  submitELMetadata,
  submitELDataFromFileCreate,
  submitELDataFromDbCreate,
  uploadElSrcFileCsvAbsolute,
  uploadElSrcFileXlsAbsolute,
  submitELDataFromFileUpdate,
  submitELDataFromDBUpdate,
  deleteELCreatedArtefacts
} from "../actions";
import {connect} from "react-redux";
import ELLoadMetadata from "./LoadMetadata";
import ELLoadData from "./LoadData";
import {getArtefactTripletFromUrn, getStringFromArtefactTriplet, getUrnFromArtefact} from "../../../utils/sdmxJson";
import {EL_MODE_CREATE, EL_SOURCE_FORMAT_CSV, EL_SOURCE_FORMAT_DB, EL_SOURCE_FORMAT_SDMX_EP, EL_SOURCE_FORMAT_XLS} from "../constants";

const mapStateToProps = state => ({
  appLanguage: state.app.language,
  nodeId: state.app.endpointId,
  nodes: state.config.nodes,
  dstDataflow: state.scenes.easyLoading.dstDataflow,
  category: state.scenes.easyLoading.category,
  connectionEndpointId: state.scenes.easyLoading.connectionEndpointId,
  srcDataflow: state.scenes.easyLoading.srcDataflow,
  filterStr: state.scenes.easyLoading.filterStr,
  isMetadataImportReportVisible: state.scenes.easyLoading.isMetadataImportReportVisible,
  metadataImportReport: state.scenes.easyLoading.metadataImportReport,
  isDataImportPending: state.scenes.easyLoading.isDataImportPending,
  dataImportReport: state.scenes.easyLoading.dataImportReport,
  dataImportStatus: state.scenes.easyLoading.dataImportStatus,
  publishDf: state.scenes.easyLoading.publishDf,
  transcodeDf: state.scenes.easyLoading.transcodeDf,
  sourceFormat: state.scenes.easyLoading.sourceFormat,
  srcFile: state.scenes.easyLoading.srcFile,
  srcTable: state.scenes.easyLoading.srcTable,
  structureColumns: state.scenes.easyLoading.structureColumns,
  loadTableExists: state.scenes.easyLoading.loadTableExists,
  artefactsCreated: state.scenes.easyLoading.artefactsCreated,
  dsdTriplet: state.scenes.easyLoading.dsdTriplet,
  createdCodelists: state.scenes.easyLoading.createdCodelists,
  conceptSchemaDefinition: state.scenes.easyLoading.conceptSchemaDefinition,
  currentMapping: state.scenes.easyLoading.currentMapping,
  components: state.scenes.easyLoading.components,
  hasToDeleteArtefacts: state.scenes.easyLoading.hasToDeleteArtefacts,
  toDeleteCodelists: state.scenes.easyLoading.toDeleteCodelists,
  toDeleteConceptSchema: state.scenes.easyLoading.toDeleteConceptSchema,
});

const mapDispatchToProps = dispatch => ({
  onMetadataSubmit: (endpointId, sdcDataflowTriplet) => dispatch(submitELMetadata(endpointId, sdcDataflowTriplet)),
  onMetadataReportHide: () => dispatch(hideElMetadataReport()),
  onPublishDfChange: publishDf => dispatch(changeElPublishDataflow(publishDf)),
  onTranscodeDfChange: transcodeDf => dispatch(changeElTranscodeDataflow(transcodeDf)),
  onDataCreateSubmit: (endpointId, sdcDataflowTriplet, dstDataflowTriplet, dsName, categoryId, filterStr, publishDf, transcodeDf) =>
    dispatch(submitELDataCreate(endpointId, sdcDataflowTriplet, dstDataflowTriplet, dsName, categoryId, filterStr, publishDf, transcodeDf)),
  onDataUpdateSubmit: (endpointId, sdcDataflowTriplet, dstDDBDataflowId, filterStr, transcodeDf) =>
    dispatch(submitELDataUpdate(endpointId, sdcDataflowTriplet, dstDDBDataflowId, filterStr, transcodeDf)),
  getImportStatus: dataflowTriplet => dispatch(getELDataImportStatus(dataflowTriplet)),
  reset: () => dispatch(resetEl()),
  onPreloadCsv: (separator, delimiter, hasHeader, filePath, tid) => 
    dispatch(preloadELCSV(separator, delimiter, hasHeader, filePath, tid)),
  onSetELLoadTableExists: (value) => dispatch(setELLoadTableExists(value)),
  onELCreateArtefacts: (structureColumns, filterStr,dstDataflow, tableName, inStagingDb, appLang) => 
    dispatch(createELArtefacts(structureColumns, filterStr,dstDataflow, tableName, inStagingDb, appLang)),
  onELDeleteArtefacts : (toDeleteCodelists, toDeleteConceptSchema) => dispatch(deleteELCreatedArtefacts(toDeleteCodelists, toDeleteConceptSchema)),
  onELCreateDsd: (structureColumns, dstDataflow, appLang, codelists, conceptSchema, astTerritoryDimId) => 
    dispatch(createELDsd(structureColumns, dstDataflow, appLang, codelists, conceptSchema, astTerritoryDimId)),
  onDataCreateFromFileSubmit : (structureColumns, astTerritoryDimId, datasetName, filePath, separator, delimiter, hasHeader, DsId, DsAg, DsVs, CategoryId,  DsdCode, mappFilePath, publishDf, executeTrans, filterStr) =>
    dispatch(submitELDataFromFileCreate(structureColumns, astTerritoryDimId, datasetName, filePath, separator, delimiter, hasHeader, DsId, DsAg, DsVs, CategoryId,DsdCode, mappFilePath, publishDf, executeTrans, filterStr)),
  onDataCreateFromDbSubmit: (structureColumns, astTerritoryDimId, tableName, datasetName, DsId, DsAg, DsVs, CategoryId, DsdCode, publishDf, executeTrans, filterStr) =>
    dispatch(submitELDataFromDbCreate(structureColumns, astTerritoryDimId, tableName, datasetName, DsId, DsAg, DsVs, CategoryId, DsdCode, publishDf, executeTrans, filterStr)),
  onDataUpdateFromFileSubmit: (datasetName, filePath,separator, delimiter, hasHeader, ddbDataflowId, currentMapping, components, mappFilePath, transcodeDf, filterStr) =>
    dispatch(submitELDataFromFileUpdate(datasetName, filePath,separator, delimiter, hasHeader, ddbDataflowId, currentMapping, components, mappFilePath, transcodeDf, filterStr)),
  onDataUpdateFromDBSubmit: (datasetName, tableName,ddbDataflowId,currentMapping,components,transcodeDf,filterStr)  => 
    dispatch(submitELDataFromDBUpdate(datasetName, tableName,ddbDataflowId,currentMapping,components,transcodeDf,filterStr)),  
  onFileCsvAbsoluteUpload : file => dispatch(uploadElSrcFileCsvAbsolute(file)), 
  onFileXlsAbsoluteUpload : (file, mappingFile) => dispatch(uploadElSrcFileXlsAbsolute(file, mappingFile)),
});

const ELLoadStep = ({
                      t,
                      appLanguage,
                      nodeId,
                      nodes,
                      mode,
                      dstDataflow,
                      category,
                      connectionEndpointId,
                      srcDataflow,
                      filterStr,
                      isMetadataImportReportVisible,
                      metadataImportReport,
                      isDataImportPending,
                      dataImportStatus,
                      dataImportReport,
                      publishDf,
                      transcodeDf,
                      sourceFormat,
                      srcFile,
                      srcTable,
                      structureColumns,
                      loadTableExists,
                      artefactsCreated,
                      dsdTriplet,
                      createdCodelists,
                      conceptSchemaDefinition,
                      currentMapping,
                      components,
                      hasToDeleteArtefacts,
                      toDeleteCodelists,
                      toDeleteConceptSchema,

                      onMetadataSubmit,
                      onMetadataReportHide,
                      onPublishDfChange,
                      onTranscodeDfChange,
                      onDataCreateSubmit,
                      onDataUpdateSubmit,
                      getImportStatus,
                      reset,
                      onPreloadCsv,
                      onSetELLoadTableExists,
                      onELCreateArtefacts,
                      onELDeleteArtefacts,
                      onELCreateDsd,
                      onDataCreateFromFileSubmit,
                      onDataCreateFromDbSubmit,
                      onDataUpdateFromFileSubmit,
                      onDataUpdateFromDBSubmit,
                      onFileCsvAbsoluteUpload,
                      onFileXlsAbsoluteUpload
                    }) => {

  const connectedNode = nodes.find(node => node.general.id === nodeId);                      

  const submitMetadata = useCallback(() => {
    if (sourceFormat === EL_SOURCE_FORMAT_SDMX_EP) {
      /* Calls "ImportDSDFromDataflow" which creates the metadata import report 
        sets the status variables
        isMetadataImportReportVisible: true,
        metadataImportReport: action.response.itemsMessage */
      onMetadataSubmit(
        connectionEndpointId,
        getArtefactTripletFromUrn(getUrnFromArtefact(srcDataflow))
      );
    } else if (sourceFormat !== EL_SOURCE_FORMAT_DB) {
      /* Calls preloadCSV to load the csv/Excel table. Sets the status variables 
        srcTable: action.response,
        loadTableExists: true
      */
      onPreloadCsv(srcFile.separator, srcFile.delimiter ? srcFile.delimiter : null, true, srcFile.csvPath, null);
    }
    else {
      /* EL_SOURCE_FORMAT_DB. Sets the variable status loadTableExists: true*/
      onSetELLoadTableExists(true);
    }        
  }, [onMetadataSubmit,onPreloadCsv,onSetELLoadTableExists, connectionEndpointId, srcDataflow, srcFile]);

  const submitDataCreate = useCallback(() => {
    if (sourceFormat === EL_SOURCE_FORMAT_SDMX_EP) {
      onDataCreateSubmit(
        connectionEndpointId,
        getArtefactTripletFromUrn(getUrnFromArtefact(srcDataflow)),
        dstDataflow,
        dstDataflow.name,
        category.IDCat,
        filterStr,
        publishDf,
        transcodeDf
      );
    } else if (sourceFormat === EL_SOURCE_FORMAT_CSV || sourceFormat === EL_SOURCE_FORMAT_XLS) {
      onDataCreateFromFileSubmit(
        structureColumns, 
        connectedNode.ast.astTerritoryDimId, 
        dstDataflow.name, 
        srcFile.fileAbsolutePath,
        srcFile.separator, 
        srcFile.delimiter ? srcFile.delimiter : null,
        true, // hasHeader
        dstDataflow.id, 
        dstDataflow.agencyID, 
        dstDataflow.version, 
        category.IDCat,
        getStringFromArtefactTriplet(dsdTriplet),
        srcFile.mappingAbsolutePath ? srcFile.mappingAbsolutePath : null,  
        publishDf,         
        transcodeDf, 
        filterStr
      );      
    } else if (sourceFormat === EL_SOURCE_FORMAT_DB) {
      onDataCreateFromDbSubmit(
        structureColumns, 
        connectedNode.ast.astTerritoryDimId, 
        srcTable, 
        dstDataflow.name, 
        dstDataflow.id, 
        dstDataflow.agencyID, 
        dstDataflow.version, 
        category.IDCat, 
        getStringFromArtefactTriplet(dsdTriplet),		  
        publishDf, 
        transcodeDf, 
        filterStr)
    }
    
  }, [connectionEndpointId, srcDataflow, dstDataflow, category, dsdTriplet,srcFile, filterStr, structureColumns, srcTable, publishDf, transcodeDf]);

  const submitDataUpdate = useCallback(() => {
    if (sourceFormat === EL_SOURCE_FORMAT_SDMX_EP) {
      onDataUpdateSubmit(
        connectionEndpointId,
        getArtefactTripletFromUrn(getUrnFromArtefact(srcDataflow)),
        dstDataflow.ddbDataflowId,
        filterStr,
        transcodeDf
      );
    } else if (sourceFormat === EL_SOURCE_FORMAT_CSV || sourceFormat === EL_SOURCE_FORMAT_XLS) {      
      onDataUpdateFromFileSubmit(
        dstDataflow.name,
        srcFile.fileAbsolutePath, 
        srcFile.separator, 
        srcFile.delimiter ? srcFile.delimiter : null,
        true, // hasHeader,
        dstDataflow.ddbDataflowId,
        currentMapping,
        components,
        srcFile.mappingAbsolutePath ? srcFile.mappingAbsolutePath : null,
        transcodeDf,
        filterStr
      )
    } else if (sourceFormat === EL_SOURCE_FORMAT_DB) {
      onDataUpdateFromDBSubmit(
        dstDataflow.name,
        srcTable,
        dstDataflow.ddbDataflowId,
        currentMapping,
        components,
        transcodeDf,
        filterStr
      )
    }
    
  }, [sourceFormat, connectionEndpointId, srcDataflow, dstDataflow, filterStr, transcodeDf, srcFile, currentMapping, components, srcTable]);

  useEffect(() => {

    if (sourceFormat === EL_SOURCE_FORMAT_CSV) {
      if (!srcFile.fileAbsolutePath) {
        onFileCsvAbsoluteUpload(srcFile.file);
      }     
     } else if (sourceFormat === EL_SOURCE_FORMAT_XLS) {
      if (!srcFile.fileAbsolutePath || !srcFile.mappingAbsolutePath) {  
          onFileXlsAbsoluteUpload(srcFile.file, srcFile.mapping);                    
      }
    }
  }, [sourceFormat, srcFile]);


  useEffect(() => {
    /* create artefacts when needed. Executes when load from DB, Excel, csv and dsd has not been created (dsdTriplet === null) */
    if (sourceFormat !== EL_SOURCE_FORMAT_SDMX_EP && dstDataflow 
    && loadTableExists && srcTable && !dsdTriplet) {      
      onELCreateArtefacts(structureColumns, filterStr, dstDataflow, srcTable, false, appLanguage);           
    }
  }, [sourceFormat,dstDataflow, dsdTriplet, structureColumns, filterStr, appLanguage, loadTableExists, srcTable]);

  
  useEffect(() => {
    /* Deletes created artfefacts in case of error */
    if (sourceFormat !== EL_SOURCE_FORMAT_SDMX_EP && hasToDeleteArtefacts) {      
      onELDeleteArtefacts(toDeleteCodelists, toDeleteConceptSchema);           
    }
  }, [sourceFormat, hasToDeleteArtefacts,toDeleteCodelists, toDeleteConceptSchema]);


  useEffect(() => {
    /* Creates the dsd when artefacts has been created and dsd has not been created */
    if (sourceFormat !== EL_SOURCE_FORMAT_SDMX_EP && artefactsCreated && !dsdTriplet) {      
      onELCreateDsd(structureColumns,dstDataflow, appLanguage,createdCodelists, conceptSchemaDefinition, connectedNode.ast.astTerritoryDimId);           
    }
  }, [sourceFormat, artefactsCreated, structureColumns, dstDataflow, createdCodelists, 
      conceptSchemaDefinition, connectedNode, dsdTriplet])

  return (
    <Fragment>
      {mode === EL_MODE_CREATE && (
        <Fragment>
          <ELLoadMetadata
            onMetadataSubmit={submitMetadata}
            metadataImportReport={metadataImportReport}
            isMetadataImportReportVisible={isMetadataImportReportVisible}
            onMetadataReportHide={onMetadataReportHide}
            dsdTriplet={dsdTriplet}
            sourceFormat={sourceFormat}
          />
          <Divider/>
        </Fragment>
      )}
      <ELLoadData
        mode={mode}
        disabled={!!dataImportReport || 
          (mode === EL_MODE_CREATE && sourceFormat === EL_SOURCE_FORMAT_SDMX_EP && metadataImportReport === null) || 
          (mode === EL_MODE_CREATE && sourceFormat !== EL_SOURCE_FORMAT_SDMX_EP && metadataImportReport === null && (dsdTriplet === null || dsdTriplet === -1))}
        onDataSubmit={mode === EL_MODE_CREATE ? submitDataCreate : submitDataUpdate}
        dataImportReport={dataImportReport}
        isDataImportPending={isDataImportPending}
        dataImportStatus={dataImportStatus}
        getImportStatus={getImportStatus}
        dstDataflow={dstDataflow}
        publishDf={publishDf}
        transcodeDf={transcodeDf}
        onPublishDfChange={onPublishDfChange}
        onTranscodeDfChange={onTranscodeDfChange}
      />
      {dataImportReport && (
        <Fragment>
          <Divider/>
          <Row type="flex" justify="center">
            <Col>
              <Button onClick={reset} icon="plus">
                {mode === EL_MODE_CREATE
                  ? t("components.easyLoading.steps.load.body.createNewData.title")
                  : t("components.easyLoading.steps.load.body.updateNewData.title")}
              </Button>
            </Col>
          </Row>
        </Fragment>
      )}
    </Fragment>
  )
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(ELLoadStep);


// WEBPACK FOOTER //
// ./src/components/easy-loading/load-step/index.jsx